import React, { useEffect, useState } from 'react';
import './common.css';
import API_URL from '../common/Apiurl';
import SuccessMessage from '../common/Message';

function Privacypolicy(){
    const apiUrl = API_URL;
    const [text, setText] = useState('');
    const [successMessages, setSuccessMessages] = useState([]);
    const handleChange = (e) => {
        setText(e.target.value);
    }
    useEffect(() => {
        const privacyData = async (e) => {
            try{
                const putResult = await fetch(`${apiUrl}/admin/getprivacypolicy`,{
                    method: 'GET',
                    headers:{
                        "Content-Type":"application/json",
                        "Accept":"application/json"
                    },
                })
                const data = await putResult.json();
                if(data.status === 200){
                    setText(data.value);
                }
            }
            catch(error){
                console.log('Error: ', error)
            }
        }
        privacyData();
    }, []);
    const privacypolicy = async (e) => { 
        e.preventDefault();
        const postData = {
            privacypolicyContent: text,
        };
        const result = await fetch(`${apiUrl}/admin/privacypolicy`,{
            method: 'POST',
            headers:{
                "Content-Type":"application/json",
                "Accept":"application/json"
            },
            body: JSON.stringify(postData)
        })
        const data = await result.json();
        if((data.status == 200)){
            const newSuccessMessage = data.message;
            setSuccessMessages([...successMessages, newSuccessMessage]);
            setText(data.value);
        }
    }
    const handleSuccessMessageFadeOut = () =>{
        setSuccessMessages((prevMessages) => prevMessages.slice(1));
        window.location.reload();
    }
    return (
            <div className='width90'>
                <h2 className='pageTitle'>Privacy Policy</h2>
                <form onSubmit={privacypolicy}>
                    <textarea
                        value={text}
                        onChange={handleChange} >{text}
                    </textarea>
                    <button type='submit' className='submitBtn submitBtnborder'>Submit</button>
                </form>  
                {
                    successMessages.map((message, index) => (
                        <SuccessMessage
                            key={index} 
                            message = {message} 
                            onFadeOut={handleSuccessMessageFadeOut}
                        />
                    )
                )} 
            </div> 
    )              
}

export default Privacypolicy;